module.exports = __webpack_public_path__ + "img/blockables-instructions-2.e4634292.png";